import type { NonEmptyArray } from '@mntn-dev/utility-types'
import { z } from 'zod'

/**
 * NoneableSchema is a schema composition function that adds 'none' to a Zod enum
 * @param schema the enum schema to add 'none' to
 * @returns A schema that accepts either the enum values or 'none'
 */
export const NoneableSchema = <T extends NonEmptyArray<string>>(
  schema: z.ZodEnum<T>
) => {
  return z.union([schema, z.literal('none')])
}
